<template>
    <label class="default-checkbox">
        <input type="checkbox" :checked="checked" class="default-checkbox__input"
               @change="$emit('change', $event.target.checked)"/>
        <span class="default-checkbox__container"></span>
        <span v-if="!hiddenLabel" class="default-checkbox__text" v-html="label"></span>
    </label>
</template>


<script setup>
import { computed } from 'vue'
defineEmits(['change']);
const props = defineProps({
    label: {
        type: String,
        default: '',
    },
    hiddenLabel: {
        type: Boolean,
        default: false,
    },
    name: {
        type: String,
        default: ''
    },
    isCheck: {
        type: Boolean,
        default: false
    }

})

const checked = computed(() => props.isCheck)
</script>
